// @ts-strict-ignore
import React, { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { EmptyState, Illustration } from '@node-space/ui-components'
import { logSentryErrorAndGetTraceId } from '@node-space/utils'
import { ExternalLink } from 'components/ExternalLink/ExternalLink'
import { ExternalLinks } from 'constants/links'

export const NoWalletProfilesEmptyState = () => {
  const { t } = useTranslation()

  useEffect(() => {
    logSentryErrorAndGetTraceId(
      `NoWalletProfilesFound`,
      new Error(
        'No wallet profiles found. Please check that wallet profiles have been correctly configured.'
      )
    )
  }, [])

  return (
    <EmptyState
      testId="no-wallet-profiles-empty-state"
      title={t('customers.noWalletProfilesTitle')}
      description={
        <>
          {t('customers.noWalletProfilesDescription')}
          <br />
          <ExternalLink href={ExternalLinks.CONTACT_SUPPORT ?? ''}>
            {t('customers.contactSupport')}
          </ExternalLink>
        </>
      }
      Illustration={<Illustration name="PermissionsDenied" />}
    />
  )
}
